import { useMutation, UseMutationOptions } from 'react-query';
import { AnrokAuthConnectRequestPayload } from '@vy/api-definition';
import { getPrivateApi } from '../../../../services/api';

export function useAnrokConnect(options?: UseMutationOptions<void, unknown, AnrokAuthConnectRequestPayload>) {
  return useMutation(async (anrokConnectRequest) => {
    const api = getPrivateApi();

    return api.anrokConnect({ anrokConnectRequest });
  }, options);
}
